// const backendUrl = "https://www.project2501.co.kr/api/cpoint/app/mbl/";
// const backendUrl = "http://43.200.13.61:9090/cpoint/app/mbl/";
const backendUrl = "";
const captchaImgUrl = "http://43.200.13.61:9090/cpoint/app/mbl/util/captchaImg";

const secretKey = 'cROosAgMdsFwr0gtu4L0Tv2jA05kfHqe';
const iv = 'ka3t8phk2rm77496';
const shopCheckKey = "NKyrVcTrS%2Fea0W0c5zcv7ZYCff9cmQ2IHGDG1tVoaoj3QXPdDNvYWBWf5DxpY7l%2BbJdL6wOt5y9skA%2BMspFBgw%3D%3D";
export { backendUrl, captchaImgUrl, secretKey, iv, shopCheckKey };